<template lang="pug">
  #wt-app(:class="{'google-translate-widget-wrapper': languageTranslatorOn}")
    GoogleTranslator
    RouterView.non-app-page-view(name="createProgram" v-if="isCreateProgram")
    template(v-else)
      TheMobileAppsNotice(v-if="isMobileDevice")
      // Authentication & Registration
      RouterView(name="auth" v-if="!$auth.check()")

      // page not found view
      RouterView(name="notFound")

      template(
        v-if="$route.name === 'ResetPassword'"
      )
        RouterView(name="resetPassword")
      template(
        v-else-if="(memberCanUseApp || wtAdminCanUseApp || extendProgram)"
      )
        ThePagesLoader(v-if="$auth.user() && $route.name === 'MyDashboard'")
        TheProgramLoader
        TheMemberLoader

        template(v-if="$auth.user() && $route.name === 'Assessment'")
          TheNavBar
          Assessment
        template(v-if="$auth.user() && $route.name !== 'Assessment'")
          TheNavBar
          .app-content
            .container
              //- TODO fix/refactor/makebetter this sitewide
              .view-title-container
                WtTitle(h1 v-if="showViewTitle && route.name !=='ChooseOrganization'") {{ viewTitle }}
              RouterView
        BModal(
          :active="displayRequiredQuestionsModal"
          has-modal-card
          trap-focus
          :can-cancel="questionModalCancelMethods"
          :on-cancel="adminDismissModal"
        )
          RequiredQuestions(
            :showDismissButton="isAdmin"
            :dismissModal="adminDismissModal"
          )
      template(v-else-if="memberCanDownloadData")
        TheProgramLoader
        TheMemberLoader
        TheNavBar

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TheWrapper from "@@/TheWrapper";
import GoogleTranslator from "@@/GoogleTranslator/GoogleTranslator";
const TheMobileAppsNotice = () =>
  import(
    /* webpackChunkName: "TheMobileAppsNotice" */ "@@/TheMobileAppsNotice"
  ).catch(() => {
    window.location.reload();
  });
import TheNavBar from "@@/NavBar/TheNavBar";
import TheProgramLoader from "@@/TheProgramLoader";
import WtTitle from "@@/WtTitle/WtTitle";
import TheMemberLoader from "@@/TheMemberLoader";
import ThePagesLoader from "@@/ThePagesLoader";
import RequiredQuestions from "@@/ProgramQuestions/RequiredQuestions";
import Assessment from "./views/Assessment";

export default {
  name: "App",

  components: {
    TheProgramLoader,
    WtTitle,
    TheNavBar,
    TheWrapper,
    TheMemberLoader,
    ThePagesLoader,
    TheMobileAppsNotice,
    GoogleTranslator,
    RequiredQuestions,
    Assessment
  },

  computed: {
    ...mapGetters([
      "darkMode",
      "mobileBreakPoint",
      "isMobile",
      "viewTitle",
      "route"
    ]),
    ...mapGetters(["expanded"]),
    ...mapGetters("members", ["memberLoaded", "member"]),
    ...mapGetters("pages", ["isPageLoaded"]),
    ...mapGetters("authMember", ["isWtAdmin", "isAdmin"]),
    ...mapGetters("program", ["coreProgramMeta"]),

    showViewTitle() {
      const pages = [
        "My Dashboard",
        "Challenges",
        "Friends",
        "Challenge Edit",
        "Teams",
        "Team Edit",
        "Profile Page"
      ];
      return !pages.includes(this.viewTitle);
    },

    isLoggedIn() {
      return this.$auth.check();
    },

    languageTranslatorOn() {
      if (this.isLoggedIn) {
        return this._.get(this.coreProgramMeta, "languageTranslator", false);
      }
      return false;
    },

    isMobileDevice() {
      // return false for mobile organizations web view only
      if (window.location.pathname.includes("/mobile/organizations/")) {
        return false;
      }
      if (window.location.pathname.includes("/mobile/challenge/")) {
        return false;
      }
      if (window.location.pathname.includes("/mobile/registration")) {
        return false;
      }
      return /iPhone|android/i.test(navigator.userAgent);
    },

    isCreateProgram() {
      return (
        window.location.pathname.includes("create-bewell") ||
        window.location.hostname.includes("setup")
      );
    },

    canUseAppBaseCheck() {
      return (
        this.$auth.check() &&
        this.$auth.ready() &&
        this.$route.matched.length > 0
      );
    },

    wtAdminCanUseApp() {
      return this.canUseAppBaseCheck && this.isWtAdmin;
    },

    memberCanUseApp() {
      return this.canUseAppBaseCheck;
    },

    memberCanDownloadData() {
      return this.canUseAppBaseCheck;
    },

    extendProgram() {
      if (process.env.VUE_APP_ENV === "prod") {
        // note, we are hardcoding this feature but have a plan to create an admin super tool
        // 2979 is chicagocow.thrives.app
        // 3206 is cfomovember.thrives.app
        let isProgramSpecial =
          this._.get(this.$auth.user(), "program.id", false) == 2979 ||
          this._.get(this.$auth.user(), "program.id", false) == 3206;
        return (
          this.canUseAppBaseCheck &&
          process.env.VUE_APP_ENV === "prod" &&
          isProgramSpecial
        );
      }
      return false;
    },

    displayRequiredQuestionsModal() {
      if (
        this.$auth.user() &&
        this.memberLoaded &&
        this.member.unansweredQuestions
      ) {
        // if user is admin and dismissed modal don't show it again
        if (this.member.dismissedRequiredModal) {
          return false;
        }
        // check if there are any required questions unanswered
        let requiredQuestions = this.member.unansweredQuestions.filter(
          q => q.required
        );
        return !!requiredQuestions.length;
      }
      return false;
    },

    questionModalCancelMethods() {
      if (this.isAdmin) {
        return ["outside", "x"];
      }
      return [];
    },

    isInsideIframe() {
      //wellpro has a terryberryCompanyUrl - but needs to run outside iframe for demo purposes
      //wellpro programId = 3691
      if (this.coreProgramMeta.id == 3691) {
        return false;
      } else {
        return !!this._.get(this.coreProgramMeta, "terryberryCompanyUrl", "");
      }
    }
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  beforeMount() {
    this.setIsMobile(false);

    if (window.innerWidth < this.mobileBreakPoint) {
      this.setIsMobile(true);
    }
  },

  methods: {
    ...mapActions(["setIsMobile"]),
    ...mapActions("members", ["updateMember"]),

    handleResize() {
      const width = window.innerWidth;

      if (width <= this.mobileBreakPoint && !this.isMobile) {
        this.setIsMobile(true);
      } else if (width >= this.mobileBreakPoint && this.isMobile) {
        this.setIsMobile(false);
      }
    },

    async adminDismissModal() {
      const response = await this.updateMember({
        memberId: this.$auth.user().id,
        formData: {
          dismissedRequiredModal: 1
        }
      });
      if (response.error) {
        this.snackBar({ message: "Your can't dismiss the modal." });
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#wt-app
  height: 100%
  .app-content
    background-color: $white-ter
    padding-bottom: 150px
    +desktop
  .view-title-container
    margin: 39px 0 30px 0
    +mobile
      margin: 23px 0 21px 0

  .non-app-page-view
    padding: 2rem 1.5rem
.google-translate-widget-wrapper
  /deep/ #navbar
    top: 37px !important
  .app-content
    padding-top: 37px
</style>
